import { RouteObject } from 'react-router-dom';
import HrDashboardView from './views/HrDashboardView';
import EmployeeListView from './views/employees/EmployeeListView';
import EmployeeCreateView from './views/employees/EmployeeCreateView';
import EmployeeDetailView from './views/employees/EmployeeDetailView';
import EmployeeEditView from './views/employees/EmployeeEditView';
import LeaveRequestView from './views/leave/LeaveRequestView';
import LeaveApprovalView from './views/leave/LeaveApprovalView';
import LeaveBalanceView from './views/leave/LeaveBalanceView';
import AttendanceView from './views/attendance/AttendanceView';
import PayrollDashboardView from './views/payroll/PayrollDashboardView';
import PayrollRunWizardView from './views/payroll/PayrollRunWizardView';
import PayrollPeriodDetailView from './views/payroll/PayrollPeriodDetailView';
import PayslipDetailView from './views/payroll/PayslipDetailView';
import HrConfigView from './views/admin/HrConfigView';
import HrAccountMappingView from './views/admin/HrAccountMappingView';
import LeaveTypesConfigView from './views/admin/LeaveTypesConfigView';
import SelfServiceDashboardView from './views/self-service/SelfServiceDashboardView';
import SelfServiceLeaveView from './views/self-service/SelfServiceLeaveView';
import SelfServicePayslipsView from './views/self-service/SelfServicePayslipsView';
import SelfServicePayslipDetailView from './views/self-service/SelfServicePayslipDetailView';
import SelfServiceProfileView from './views/self-service/SelfServiceProfileView';
import SelfServiceAttendanceView from './views/self-service/SelfServiceAttendanceView';

export const hrRoutes: RouteObject[] = [
  { path: '/hr', element: <HrDashboardView /> },

  // Employees (HR admin)
  { path: '/hr/employees', element: <EmployeeListView /> },
  { path: '/hr/employees/create', element: <EmployeeCreateView /> },
  { path: '/hr/employees/:id', element: <EmployeeDetailView /> },
  { path: '/hr/employees/:id/edit', element: <EmployeeEditView /> },

  // Leave (HR admin)
  { path: '/hr/leave/requests', element: <LeaveRequestView /> },
  { path: '/hr/leave/approvals', element: <LeaveApprovalView /> },
  { path: '/hr/leave/balances', element: <LeaveBalanceView /> },

  // Attendance (HR admin)
  { path: '/hr/attendance', element: <AttendanceView /> },

  // Payroll (HR admin)
  { path: '/hr/payroll', element: <PayrollDashboardView /> },
  { path: '/hr/payroll/new', element: <PayrollRunWizardView /> },
  { path: '/hr/payroll/:id', element: <PayrollPeriodDetailView /> },
  { path: '/hr/payroll/:id/payslips/:entryId', element: <PayslipDetailView /> },

  // Admin / Config
  { path: '/admin/hr/config', element: <HrConfigView /> },
  { path: '/admin/hr/leave-types', element: <LeaveTypesConfigView /> },
  { path: '/admin/hr/account-mappings', element: <HrAccountMappingView /> },

  // Employee Self-Service
  { path: '/hr/self-service', element: <SelfServiceDashboardView /> },
  { path: '/hr/self-service/profile', element: <SelfServiceProfileView /> },
  { path: '/hr/self-service/leave', element: <SelfServiceLeaveView /> },
  { path: '/hr/self-service/payslips', element: <SelfServicePayslipsView /> },
  { path: '/hr/self-service/payslips/:id', element: <SelfServicePayslipDetailView /> },
  { path: '/hr/self-service/attendance', element: <SelfServiceAttendanceView /> },
];
